import { useEffect, useState } from 'react'
import { IRejectedNoteDTO } from '@user/store/opportunity'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@sales-center/common'

type State = {
  loading: boolean
  note?: IRejectedNoteDTO
}

const initialState: State = {
  loading: false,
  note: undefined,
}

const baseUrl = `${ServiceConfig.baseAPIUrl}/Opportunity`

export const useGetRejectedNote = (opportunityId: number) => {
  const [state, setState] = useState<State>(initialState)

  async function loadData(oppId) {
    const response = await get(
      `${baseUrl}/${oppId}${ServiceConfig.opportunity.rejectedNote}`,
    )
    if (response.ok) {
      const payload: IRejectedNoteDTO = await response.json()
      setState((s) => ({ ...s, note: payload }))
    }

    setState((s) => ({ ...s, loading: false }))
  }

  useEffect(() => {
    setState((s) => ({
      ...s,
      loading: true,
    }))

    loadData(opportunityId)
  }, [opportunityId])

  return [state.loading, state.note] as const
}
